import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AppService } from 'src/app/core/services/app.service';
import { FocuslinkService } from 'src/app/core/services/focuslink.service';
import { UserService } from 'src/app/core/services/user.service';
import { OOVenueService } from 'src/app/core/services/venue-service';
import { GenericLabelValue } from 'src/app/shared/models/DTO/GenericLabelValue.dto';

@Component({
	selector: 'app-payment-processor-focuspay-datacap',
	templateUrl: './payment-processor-focuspay-datacap.component.html',
	styleUrls: ['../../../../commandcenter.scss'],
})
export class PaymentProcessorFocuspayDatacapComponent implements OnInit {
	@Input() changesToSave: boolean;
	@Output() changesToSaveChange = new EventEmitter<boolean>();

	@Input() ccProcessors: GenericLabelValue[];

	constructor(public app: AppService, public venueService: OOVenueService, public userService: UserService, private focuslink: FocuslinkService) {}

	ngOnInit(): void {
		console.log(this.userService.userSubscription.value);
	}

	onChange() {
		this.changesToSaveChange.emit(true);
	}

	async saveVenue() {
		const resp = await this.focuslink.venueSave(this.venueService.subscriptionVenue.value.key, this.venueService.subscriptionVenue.value);
	}
}
